import { get, postApi } from './index';
import convertToQueryParams from '../utils/convertToQueryParams';

/** Shared by buyer app and dashboard; backend scopes by auth token. */
const NOTIFICATIONS_BASE = 'system/notifications/';

function withQuery(path, params = {}) {
  const query = convertToQueryParams(params);
  return query ? `${path}${query}` : path;
}

export function fetchNotificationsList(params = {}) {
  return get(withQuery(NOTIFICATIONS_BASE, params));
}

export function fetchUnreadNotifications(params = {}) {
  return get(withQuery(`${NOTIFICATIONS_BASE}unread/`, params));
}

export function fetchUnreadCount() {
  return get(`${NOTIFICATIONS_BASE}count/`);
}

export function markNotificationAsRead(timestamps) {
  return postApi(`${NOTIFICATIONS_BASE}mark_as_read/`, { timestamps });
}

export function markAllNotificationsAsRead() {
  return postApi(`${NOTIFICATIONS_BASE}mark_all_as_read/`, {});
}
